<template>
	<!-- 应用根容器 -->
	<div id="app">
		<scale-box :width="1920" :height="1080" bgc="transparent" :autoScale="false" :delay="100">
			<!-- 当路由设置了 keepAlive 元信息时，使用 keep-alive 缓存视图 -->
			<keep-alive v-if="$route.meta.keepAlive">
				<!-- 显示当前路由对应的组件视图 -->
				<router-view />
			</keep-alive>
			<!-- 否则直接显示，不缓存 -->
			<router-view v-else />
		</scale-box>
	</div>
</template>
<script>
// import ScaleBox from "vue2-scale-box";
import ScaleBox from "v-scale-screen";
 
export default {
    components: { ScaleBox },
};
</script>
<style>
	.popoverclass {
		background-color: #071f39 !important;
		color: #fff !important;
	}

	/* 修改 Element Plus 加载时转圈图标大小 */
	.el-loading-spinner i {
		font-size: 60px;
		/* 设置图标大小为 60px */
	}

	/* 修改 Element Plus 加载中文本的字体样式 */
	.el-loading-text {
		font-family: SourceHanSansBlob;
		/* 使用自定义字体 */
		font-size: 16px !important;
		/* 强制字体大小为 16px */
	}

	/* 引入字体 ddingproSemiBold（定制字体） */
	@font-face {
		font-family: ddingproSemiBold;
		/* 定义字体名称 */
		src: url("./assets/font/ddingproSemiBold.otf");
		/* 字体文件路径 */
		font-weight: normal;
		/* 字重 */
		font-style: normal;
		/* 字体样式 */
	}

	/* 引入字体 ddingproBlob（定制字体） */
	@font-face {
		font-family: ddingproBlob;
		src: url("./assets/font/ddinproBlob.otf");
		font-weight: normal;
		font-style: normal;
	}

	/* 应用 ddingproBlob 字体样式类 */
	.ddingproBlob {
		font-family: ddingproBlob;
	}

	/* 应用 ddingproSemiBold 字体样式类 */
	.ddingproSemiBold {
		font-family: ddingproSemiBold;
	}

	/* 引入字体 SourceHanSansBlob（思源黑体加粗） */
	@font-face {
		font-family: SourceHanSansBlob;
		src: url("./assets/font/SourceHanSansCN-Bold.ttf");
		font-weight: normal;
		font-style: normal;
	}

	/* 引入字体 SourceHanSansMedium（思源黑体中等） */
	@font-face {
		font-family: SourceHanSansMedium;
		src: url("./assets/font/SourceHanSansCN-Medium.ttf");
		font-weight: normal;
		font-style: normal;
	}

	/* 引入字体 SourceHanSansRegular（思源黑体常规） */
	@font-face {
		font-family: SourceHanSansRegular;
		src: url("./assets/font/SourceHanSansCN-Regular.ttf");
		font-weight: normal;
		font-style: normal;
	}

	/* 应用思源加粗字体样式 */
	.SourceHanSansBlob {
		font-family: SourceHanSansBlob;
	}

	/* 应用思源中等字体样式 */
	.SourceHanSansMedium {
		font-family: SourceHanSansMedium;
	}

	/* 应用思源常规字体样式 */
	.SourceHanSansRegular {
		font-family: SourceHanSansRegular;
	}

	/* 引入字体 DINAlternateBold（数字字体） */
	@font-face {
		font-family: DINAlternateBold;
		src: url("./assets/font/DINAlternateBold.ttf");
		font-weight: normal;
		font-style: normal;
	}

	/* 应用 DINAlternateBold 字体样式 */
	.DINAlternateBold {
		font-family: DINAlternateBold;
	}

	/* 引入字体 优设标题黑 */
	@font-face {
		font-family: YouSheBiaoTiHei;
		src: url("./assets/font/YouSheBiaoTiHei.ttf");
		font-weight: normal;
		font-style: normal;
	}

	/* 应用优设标题黑字体样式 */
	.YouSheBiaoTiHei {
		font-family: YouSheBiaoTiHei;
	}

	/* 单行文本省略号样式 */
	.textOne {
		display: -webkit-box;
		/* 弹性布局 */
		-webkit-box-orient: vertical;
		/* 垂直排列 */
		-webkit-line-clamp: 1;
		/* 限制为一行 */
		overflow: hidden;
		/* 超出部分隐藏 */
		text-overflow: ellipsis;
		/* 省略号显示 */
	}

	/* 两行文本省略号样式 */
	.textTwo {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		/* 限制为两行 */
		overflow: hidden;
		text-overflow: ellipsis;
	}

	/* 调整 el-image-viewer 的操作按钮偏移位置 */
	.el-image-viewer__actions {
		left: 10% !important;
		/* 强制靠左 10% 位置 */
	}
</style>

<style lang="scss">
	/* 应用主容器样式 */
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		/* 默认字体列表 */
		-webkit-font-smoothing: antialiased;
		/* WebKit 字体抗锯齿优化 */
		-moz-osx-font-smoothing: grayscale;
		/* Mac 系统字体优化 */
		color: #2c3e50;
		/* 主文字颜色 */
		width: 100%;
		/* 全宽 */
		height: 100%;
		/* 全高 */
	}

	/* 页面 body 样式初始化 */
	body {
		width: 100%;
		height: 100%;
		padding: 0;
		/* 去除内边距 */
		margin: 0;
		/* 去除外边距 */
		border-radius: 0;
		/* 去圆角 */
	}

	/* 通用 Flex 布局 */
	.flex {
		display: flex;
	}

	/* Flex 垂直布局 */
	.flexCol {
		display: flex;
		flex-direction: column;
	}

	/* Flex 垂直居中 */
	.alit {
		align-items: center;
	}

	/* Flex 两端对齐 */
	.justb {
		justify-content: space-between;
	}

	/* Flex 水平居中 */
	.justc {
		justify-content: center;
	}

	/* 禁止文本选择 */
	.noselect {
		user-select: none;
		-webkit-user-select: none;
		/* Safari */
		-moz-user-select: none;
		/* Firefox */
		-ms-user-select: none;
		/* IE 10 and IE 11 */
	}

	/* 页面中标题样式，含背景图 */
	.title {
		width: 410px;
		height: 38px;
		background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E6%A0%87%E9%A2%98%402x.png");
		/* 背景图 */
		background-size: 100% 100%;
		/* 拉伸填满 */
		font-family: YouSheBiaoTiHei;
		/* 使用优设标题黑字体 */
		font-size: 20px;
		color: #c4dcf0;
		line-height: 38px;
		/* 垂直居中对齐 */
		padding-left: 30px;
		/* 左内边距留给背景图装饰 */
	}

	/* 顶部黑色渐变遮罩，用于提升视觉层次感 */
	.top-bg {
		width: 100vw;
		/* 全屏宽 */
		height: 25vh;
		/* 高度为视口高度的25% */
		background-image: linear-gradient(180deg,
				rgba(4, 5, 5, 0.9) 0%,
				rgba(255, 255, 255, 0) 100%);
		/* 黑色到底部渐变透明 */
		position: fixed;
		top: 0;
		z-index: 90;
		/* 层级较高 */
		pointer-events: none;
		/* 不可点击穿透 */
	}

	/* 底部黑色渐变遮罩 */
	.bottom-bg {
		width: 100vw;
		height: 20vh;
		background-image: linear-gradient(0deg,
				rgba(4, 5, 5, 0.9) 0%,
				rgba(255, 255, 255, 0) 100%);
		/* 从下到上渐变 */
		position: fixed;
		bottom: 0;
		z-index: 90;
		pointer-events: none;
	}
</style>